import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var SoftKeyboardTrigger = /** @class */ (function (_super) {
    __extends(SoftKeyboardTrigger, _super);
    function SoftKeyboardTrigger() {
        return _super.call(this) || this;
    }
    SoftKeyboardTrigger.classInitializer = null;
    SoftKeyboardTrigger.classSymbols = null;
    SoftKeyboardTrigger.instanceSymbols = null;
    // JS -> AS Bindings
    SoftKeyboardTrigger.CONTENT_TRIGGERED = 'contentTriggered';
    SoftKeyboardTrigger.USER_TRIGGERED = 'userTriggered';
    return SoftKeyboardTrigger;
}(ASObject));
export { SoftKeyboardTrigger };
